import {
  EnhancedBoxCastFlowControlTooltipHTML,
  MaximumBoxCastFlowControlTooltipHTML,
} from '../../utils/boxcast_flow_control';
import { sourceRtmpStatus, sourceType, sortSources } from '../../utils/sources';
import { VideoAudioConfig } from '../../utils/video-and-audio-config';
import isStreamMonkey from '../../utils/isStreamMonkey';

const STATIC_RTMP_REFRESH_INTERVAL = 10000;

export default class BoxCastersController {
  constructor(
    BoxCaster,
    Broadcast,
    StaticRTMP,
    ConfirmDialog,
    $uibModal,
    $state,
    $q,
    $rootScope,
    $location,
    $timeout,
    toaster,
    $scope
  ) {
    'ngInject';

    this.BoxCaster = BoxCaster;
    this.Broadcast = Broadcast;
    this.StaticRTMP = StaticRTMP;
    this.ConfirmDialog = ConfirmDialog;
    this.$uibModal = $uibModal;
    this.$state = $state;
    this.$q = $q;
    this.toaster = toaster;
    this.$location = $location;
    this.$timeout = $timeout;
    this.account = $rootScope.account;
    this.FeatureFlags = this.account.feature_flags;
    this.user = $rootScope.user;
    this.rtmpStatus = sourceRtmpStatus;
    this.sourceType = sourceType;
    this.url = $state.current.name;
    this.producerTestURL = window.VUE_DASHBOARD_ROOT + '/producer/test';
    this.allowRtmp = this.FeatureFlags.rtmp;
    this.allowBroadcaster = !this.FeatureFlags.broadcaster_app_source_disabled;
    this.showBroadcasterSource =
      !this.FeatureFlags.broadcaster_app_source_disabled &&
      this.account.usage_flags.broadcaster_app;
    this.showProducerSource = this.FeatureFlags.producer;
    this.isStreamMonkey = isStreamMonkey(this.account.migration_service_id);
    this.refresh().then(() => {
      this.openAndFocusOnSource();
      this.scheduleRefreshStaticRTMP();
    });

    this.getProducerEnterURL = this.getProducerEnterURL.bind(this);

    $scope.$on('$destroy', () => {
      $timeout.cancel(this.timeoutHandle);
    });

    this.showAddSourceModal = this.showAddSourceModal.bind(this);
    this.sortSources = sortSources.bind(this);
    this.toggleDetails = this.toggleDetails.bind(this);
  }

  get isSourcesPage() {
    return this.getLocation() && this.getLocation().includes('sources');
  }

  getProducerEnterURL(source) {
    if (source.details && source.details.id)
      return window.VUE_DASHBOARD_ROOT + '/producer/' + source.details.id;
    return window.VUE_DASHBOARD_ROOT + '/producer/new';
  }

  openAndFocusOnSource() {
    // XXX: must be called after `refresh()`
    const { $location, $q, $timeout } = this;

    var query = $location.search();
    if (this.account.isTrialing() && Object.keys(query).length == 0) {
      if (this.staticRTMPs.length == 1) {
        query.static_rtmp_id = this.staticRTMPs[0].id;
      }
    }
    var scrollToId;

    // BoxCaster
    if (query.boxcaster_id) {
      var b = _.find(this.boxcasters, { id: query.boxcaster_id });
      if (b && !b.__showDetails) {
        this.toggleDetails(b);
        scrollToId = `#boxcaster-${b.id}`;
      }
    }

    // Static RTMP Channel
    if (query.static_rtmp_id) {
      var r = _.find(this.staticRTMPs, { id: query.static_rtmp_id });
      if (r && !r.__showDetails) {
        this.toggleDetails(r);
        scrollToId = `#rtmp-${query.static_rtmp_id}`;
      }
    }

    // Broadcaster
    if (query.broadcaster_app) {
      var b = _.find(this.allSources, { is_broadcaster: true });
      if (b && !b.__showDetails) {
        this.toggleDetails(b);
        scrollToId = '#broadcaster-';
      }
    }

    if (scrollToId) {
      $timeout(() => {
        $('html, body').animate({ scrollTop: $(scrollToId).offset().top - 90 });
      }, 10);
    }
  }

  startTest(b) {
    const { ConfirmDialog, Broadcast, $state } = this;
    let modalOptions = {
      closeButtonText: 'Cancel',
      actionButtonText: 'Start Test Broadcast',
      actionButtonClass: 'primary',
      headerText: 'Please Confirm',
      bodyText: 'Would you like to run a test broadcast?',
    };
    ConfirmDialog.show(modalOptions).then(() => {
      var params;
      if (sourceType(b) == 'rtmp') {
        // Static RTMP
        params = { stream_source: 'rtmp', static_rtmp_id: b.id };
      } else if (sourceType(b) == 'broadcaster') {
        // Broadcaster
        params = { stream_source: 'app' };
      } else {
        // BoxCaster
        params = { stream_source: 'boxcaster', boxcaster_id: b.id };
      }
      var newBroadcast = Broadcast.save(
        angular.extend(params, {
          name: 'Test',
          starts_at: 'now',
          stops_at: moment().add(30, 'minutes').toISOString(),
          is_private: true,
        })
      );
      newBroadcast.$promise.then(() => {
        console.log('Broadcast saved', newBroadcast);
        $state.go('events.detail', { id: newBroadcast.id });
      });
    });
  }

  refresh() {
    const { StaticRTMP, BoxCaster, Broadcast, $q } = this;

    this.boxcasters = BoxCaster.query({ l: 1000, s: 'name' });
    // Get all live now broadcasts to match up stream sources
    this.broadcasts = Broadcast.query({ q: 'timeframe:current', l: 100 });

    // Figure out which Static RTMPs are active
    this.broadcastsByBoxCaster = {};
    this.broadcastsByStaticRTMP = {};
    this.broadcastsByBroadcaster = {};
    this.broadcastsByProducer = {};

    var allPromises;
    var promises = [this.boxcasters.$promise, this.broadcasts.$promise];
    if (this.allowRtmp) {
      this.staticRTMPs = StaticRTMP.query({ l: 1000, include_diagnostics: true });
      promises.push(this.staticRTMPs.$promise);
    }

    allPromises = $q.all(promises).then(() => {
      this.broadcasts.forEach((b) => {
        if (b.stream_source == 'rtmp') {
          this.broadcastsByStaticRTMP[b.static_rtmp_id] = b;
        } else if (b.stream_source == 'boxcaster') {
          this.broadcastsByBoxCaster[b.boxcaster_id] = b;
        } else if (b.stream_source == 'app') {
          this.broadcastsByBroadcaster['__sentinel__'] = b;
        } else if (b.stream_source == 'producer') {
          this.broadcastsByProducer['__sentinel__'] = b;
        }
      });
    });

    // Wait for all data, then massage it a bit
    allPromises.then(() => {
      this.loaded = true;
      // Collapse BoxCasters and RTMP addresses into 1 big ordered list
      this.allSources = (this.boxcasters || []).concat(this.staticRTMPs || []);

      // Add Broadcaster
      if (this.showBroadcasterSource) {
        var broadcasterDetails = {};
        if (this.broadcastsByBroadcaster['__sentinel__']) {
          broadcasterDetails = this.broadcastsByBroadcaster['__sentinel__'];
        }
        this.allSources = this.allSources.concat({
          is_broadcaster: true,
          name: 'Broadcaster App',
          details: broadcasterDetails,
        });
      }

      // Add Producer
      if (this.showProducerSource) {
        var producerDetails = {};
        if (this.broadcastsByProducer['__sentinel__']) {
          producerDetails = this.broadcastsByProducer['__sentinel__'];
        }
        this.allSources = this.allSources.concat({
          is_producer: true,
          name: 'Producer',
          details: producerDetails,
        });
      }

      // Sort the big list
      sortSources(this.allSources, this.broadcastsByStaticRTMP);
    });

    this.loadingPromises = [allPromises];
    return allPromises;
  }

  scheduleRefreshStaticRTMP() {
    if (this.allowRtmp && this.staticRTMPs && this.staticRTMPs.length > 0) {
      let staticRTMPs = this.StaticRTMP.query({ l: 1000, include_diagnostics: true });
      staticRTMPs.$promise
        .then(() => {
          for (var i = 0; i < this.allSources.length; i++) {
            if (sourceType(this.allSources[i]) == 'rtmp') {
              this.allSources[i].diagnostics =
                _.find(staticRTMPs, (r) => r.id == this.allSources[i].id).diagnostics ||
                this.allSources[i].diagnostics;
            }
          }
          this.staticRTMPRefreshInterval = STATIC_RTMP_REFRESH_INTERVAL;
        })
        .catch((error) => {
          console.log(error);
          // Exponential backoff up to 2 mins
          this.staticRTMPRefreshInterval = Math.min(
            (this.staticRTMPRefreshInterval || STATIC_RTMP_REFRESH_INTERVAL) * 2,
            120000
          );
        })
        .finally(() => {
          this.timeoutHandle = this.$timeout(
            () => this.scheduleRefreshStaticRTMP(),
            this.staticRTMPRefreshInterval
          );
        });
    }
  }

  toggleDetails(b, loadBoxcaster = false) {
    if (b.__showDetails) {
      b.__showDetails = false;
    } else {
      b.__showDetails = true;
      if (loadBoxcaster) {
        b.details = this.BoxCaster.get({ id: b.id });
      }
    }
  }

  editBoxCasterSettings(boxcaster) {
    const { $uibModal, BoxCaster } = this;
    const parentVM = this;

    $uibModal
      .open({
        template: require('../sources/modal-edit-boxcaster.html'),
        controllerAs: 'vm',
        backdrop: 'static', // don't allow accidental clicks on backdrop to close
        controller: function ($rootScope, $sce, $uibModalInstance, toaster) {
          'ngInject';

          const { ApiConfig, account } = $rootScope;
          const FeatureFlags = account.feature_flags;

          this.audioSliderOptions = {
            floor: -15.0,
            ceil: 15.0,
            step: 3,
            showTicks: true,
            translate: function (value) {
              return `${value > 0 ? '+' : ''}${value} dBFS`;
            },
          };

          this.videoBitrates = _.filter(VideoAudioConfig.boxcaster.video_bitrates, (b) =>
            _.contains(b.serial_prefixes, boxcaster.id[0])
          );
          this.audioBitrates = _.filter(VideoAudioConfig.boxcaster.audio_bitrates, (b) =>
            _.contains(b.serial_prefixes, boxcaster.id[0])
          );
          this.videoResolutions = _.filter(
            ApiConfig.boxcaster.video_resolutions,
            (b) =>
              _.contains(b.serial_prefixes, boxcaster.id[0]) &&
              (b.value == 'default' || b.value <= account.resolution_limit)
          );
          this.audioSources = _.filter(ApiConfig.boxcaster.audio_sources, (b) =>
            _.contains(b.serial_prefixes, boxcaster.id[0])
          );
          this.highFrameRates = _.filter(ApiConfig.boxcaster.high_frame_rates, (b) =>
            _.contains(b.serial_prefixes, boxcaster.id[0])
          );
          this.dscpValues = ApiConfig.boxcaster.dscp_values;
          this.bufferLatencies = _.filter(ApiConfig.boxcaster.buffer_latencies, (b) =>
            _.contains(b.serial_prefixes, boxcaster.id[0])
          );

          this.boxcaster = BoxCaster.get(
            { id: boxcaster.id },
            (b) => (this.pristineBoxcaster = angular.copy(b))
          );
          this.isPro = boxcaster.id[0] === 'p';
          this.isHDSD2 = boxcaster.id[0] === 'o';

          this.showOptionTargetBufferLatency =
            (this.isPro || this.isHDSD2) && !account.feature_flags.boxcast_flow_control_disabled;
          this.targetBufferLatencyTooltip = $sce.trustAsHtml(
            this.isPro
              ? MaximumBoxCastFlowControlTooltipHTML
              : EnhancedBoxCastFlowControlTooltipHTML
          );

          this.boxcaster.$promise.then(() => {
            this.hasWifi = this.boxcaster.hasWifi();
            this.isOnline = this.boxcaster.status == 'ready';
            this.canConfigureWifi = this.hasWifi && this.isOnline;
          });

          this.limits = $rootScope.ApiConfig.modelFieldLimits('boxcaster', 'maximum');

          this.isAudioOnly = () => {
            return !!((this.boxcaster || {}).target_video_bitrate <= AUDIO_ONLY_BITRATE_HINT);
          };

          // Keep track of loading state of AJAX requests
          this.loadingPromises = [this.boxcaster.$promise];

          this.cancel = () => $uibModalInstance.dismiss('cancel');

          this.settingsUnchanged = () => angular.equals(this.boxcaster, this.pristineBoxcaster);

          this.saveSettings = () => {
            if (!this.boxcaster.name) {
              this.showError = true;
              return;
            }
            this.showError = false;
            this.savingSettings = true;
            BoxCaster.update(
              { id: this.boxcaster.id },
              this.boxcaster,
              () => $uibModalInstance.close(this.boxcaster),
              (error) => {
                this.savingSettings = false;
                toaster.pop('warning', 'Unable to save configuration. Please try again.');
              }
            );
          };
        },
      })
      .result.then(() => this.refresh());
  }

  editWifi(boxcaster) {
    const { $uibModal, BoxCaster } = this;
    const parentVM = this;

    $uibModal
      .open({
        template: require('../sources/modal-edit-wifi.html'),
        controllerAs: 'vm',
        controller: function (
          $rootScope,
          $uibModalInstance,
          $scope,
          WifiConfigurationService,
          toaster
        ) {
          'ngInject';

          const { ApiConfig, account } = $rootScope;
          const FeatureFlags = account.feature_flags;

          this.videoBitrates = _.filter(VideoAudioConfig.boxcaster.video_bitrates, (b) =>
            _.contains(b.serial_prefixes, boxcaster.id[0])
          );
          this.audioBitrates = _.filter(VideoAudioConfig.boxcaster.audio_bitrates, (b) =>
            _.contains(b.serial_prefixes, boxcaster.id[0])
          );
          this.videoResolutions = _.filter(
            ApiConfig.boxcaster.video_resolutions,
            (b) =>
              _.contains(b.serial_prefixes, boxcaster.id[0]) &&
              (b.value == 'default' || b.value <= account.resolution_limit)
          );
          this.audioSources = _.filter(ApiConfig.boxcaster.audio_sources, (b) =>
            _.contains(b.serial_prefixes, boxcaster.id[0])
          );
          this.highFrameRates = _.filter(ApiConfig.boxcaster.high_frame_rates, (b) =>
            _.contains(b.serial_prefixes, boxcaster.id[0])
          );
          this.dscpValues = ApiConfig.boxcaster.dscp_values;

          this.boxcaster = BoxCaster.get({ id: boxcaster.id });
          this.isPro = boxcaster.id[0] === 'p';

          this.boxcaster.$promise.then(() => {
            this.hasWifi = this.boxcaster.hasWifi();
            this.isOnline = this.boxcaster.status == 'ready';
            this.canConfigureWifi = this.hasWifi && this.isOnline;
            if (this.canConfigureWifi) {
              this.refreshWifiConfig();
              $scope.$on('$destroy', () => {
                WifiConfigurationService.destroy && WifiConfigurationService.destroy();
              });
            }
          });

          this.deleteNetwork = (network) => {
            if (!confirm(`Are you sure you want to forget the network ${network.ssid}?`)) {
              return;
            }
            this.wifiConfig.current.networks.splice(
              this.wifiConfig.current.networks.indexOf(network),
              1
            );
            this.saveWirelessChanges();
          };

          this.addNetwork = (network) => {
            if (!network.ssid || !network.password) {
              return;
            }
            this.wifiConfig.current.networks.push({
              ssid: network.ssid,
              password: network.password,
            });
            this.showNetworkEntry = null;
            this.saveWirelessChanges();
          };

          // Keep track of loading state of AJAX requests
          this.loadingPromises = [this.boxcaster.$promise];

          this.cancel = () => $uibModalInstance.dismiss('cancel');
          this.showUnsecuredHelp = () => {
            $uibModal.open({
              template: require('../settings/modal-unsecured-help.html'),
              controller: ($scope, $uibModalInstance) => {
                'ngInject';
                $scope.cancel = () => $uibModalInstance.dismiss('cancel');
              },
            });
          };

          this.refreshWifiConfig = () => {
            this.wifiConfig = WifiConfigurationService.getConfig(boxcaster.id).then(
              (response) => {
                // De-deupe the scan results
                response.scan_results = _.uniq(response.scan_results, 'ssid');
                // Extract the list of connected networks
                this.wifiConnected = _.findWhere(response.scan_results, { connected: true });
                // Restructure as dictionary for efficient lookup later
                this.wifiConfig = response;
                this.wifiConfigDict = {};
                response.scan_results.forEach((network) => {
                  this.wifiConfigDict[network.ssid] = network;
                });
                // Filter out blank SSIDs or those that are already in the connected list from scan results
                _.remove(response.scan_results, (r) => !r.ssid || r.connected);
              },
              (error) => {
                this.wifiConfig = { error: true };
                this.wifiConnected = null;
              }
            );
          };

          this.signalStrengthForNetwork = (network) => {
            return (this.wifiConfigDict[network.ssid] || {}).signal_strength;
          };

          this.saveWirelessChanges = () => {
            this.savingWireless = true;
            WifiConfigurationService.setConfig(boxcaster.id, this.wifiConfig.current).then(
              (response) => {
                this.savingWireless = false;
                this.refreshWifiConfig();
              },
              (error) => {
                this.savingWireless = false;
                toaster.pop('warning', 'Unable to save wireless configuration. Please try again.');
              }
            );
          };
        },
      })
      .result.then(() => this.refresh());
  }

  showAddSourceModal(sourceToAdd, params = {}) {
    const { $uibModal } = this;
    const parentVM = this;

    $uibModal.open({
      template: require('../sources/modal-add-source.html'),
      controller: require('../sources/modal-add-source.js').default,
      controllerAs: 'vm',
      size: 'lg',
      resolve: {
        parentVM: () => parentVM,
        onlyShowEncoderGuides: () => false,
        sourceToAdd: () => sourceToAdd,
        params: () => params,
      },
    });
  }

  showEncoderGuides() {
    const { $uibModal } = this;
    const parentVM = this;

    $uibModal.open({
      template: require('../sources/modal-encoder-guides.html'),
      controller: require('../sources/modal-add-source.js').default,
      controllerAs: 'vm',
      size: 'lg',
      resolve: {
        parentVM: () => parentVM,
        onlyShowEncoderGuides: () => true,
        sourceToAdd: () => 'rtmp',
        params: () => ({}),
      },
    });
  }

  editRTMP(staticRTMP) {
    const { $uibModal, StaticRTMP, ConfirmDialog, toaster } = this;
    const parentVM = this;

    $uibModal
      .open({
        template: require('../sources/modal-edit-rtmp.html'),
        controllerAs: 'vm',
        controller: function ($rootScope, $uibModalInstance, toaster) {
          'ngInject';

          this.limits = $rootScope.ApiConfig.modelFieldLimits('static_rtmp', 'maximum');

          this.staticRTMP = StaticRTMP.get({ id: staticRTMP.id });

          // Keep track of loading state of AJAX requests
          this.loadingPromises = [this.staticRTMP.$promise];

          this.cancel = () => $uibModalInstance.dismiss('cancel');

          this.delete = () => {
            let modalOptions = {
              closeButtonText: 'Cancel',
              actionButtonText: 'Delete RTMP Source',
              actionButtonClass: 'danger',
              headerText: 'Please Confirm',
              bodyText:
                'Are you sure you want to delete this RTMP source? Any encoders using this stream key and server URL will need to be updated.',
            };
            ConfirmDialog.show(modalOptions).then(() => {
              StaticRTMP.delete(
                { id: this.staticRTMP.id },
                () => {
                  $uibModalInstance.close(this.staticRTMP);
                  // remove the recently deleted source from the list of sources in the UI
                  this.allSources.splice(
                    this.allSources.findIndex((s) => s.id == this.staticRTMP.id),
                    1
                  );
                },
                (err) => {
                  if (
                    err.status == 409 &&
                    err.data.error_description.indexOf('upcoming broadcast') >= 0
                  ) {
                    console.error(err);
                    toaster.pop(
                      'warning',
                      `There is at least one upcoming broadcast that uses this RTMP source. Please update all upoming broadcasts to use a different source and then try again.`
                    );
                  } else {
                    console.error(err);
                    toaster.pop('warning', 'Unable to delete RTMP source. Please try again.');
                  }
                }
              );
            });
          };

          this.saveSettings = () => {
            if (!this.staticRTMP.name) {
              this.showError = true;
              return;
            }
            this.showError = false;
            this.savingSettings = true;
            StaticRTMP.update(
              { id: this.staticRTMP.id },
              { name: this.staticRTMP.name, description: this.staticRTMP.description },
              () => $uibModalInstance.close(this.staticRTMP),
              (error) => {
                this.savingSettings = false;
                toaster.pop('warning', 'Unable to save configuration. Please try again.');
              }
            );
          };
        },
      })
      .result.then(() => this.refresh());
  }

  renameStaticRTMP(staticRTMP, newName) {
    const { StaticRTMP, toaster } = this;

    staticRTMP._saving = true;

    StaticRTMP.update(
      { id: staticRTMP.id },
      { name: newName },
      () => {
        staticRTMP._saving = false;
        staticRTMP._showRename = false;
        toaster.pop('success', 'Successfully renamed RTMP channel');
        this.refresh();
      },
      (err) => {
        console.error(err);
        staticRTMP._saving = false;
        toaster.pop('warning', 'Error renaming RTMP channel. Please try again.');
      }
    );
  }

  regenerateStreamKey(staticRTMP) {
    const { StaticRTMP, ConfirmDialog, toaster } = this;

    let modalOptions = {
      closeButtonText: 'Cancel',
      actionButtonText: 'Regenerate Stream Key',
      actionButtonClass: 'danger',
      headerText: 'Please Confirm',
      bodyText:
        'Are you sure you want to change the stream key? The old key will be immediately removed, and your encoder must be updated with the new key before your broadcasts can continue.',
    };

    ConfirmDialog.show(modalOptions).then(() => {
      StaticRTMP.update(
        { id: staticRTMP.id },
        { regenerate_stream_key: true },
        () => {
          toaster.pop('success', 'Successfully re-generated stream key');
          this.refresh();
        },
        (err) => {
          console.error(err);
          toaster.pop('warning', 'Unable to regenerate stream key. Please try again.');
        }
      );
    });
  }

  getLocation() {
    return window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
  }
}



// WEBPACK FOOTER //
// ./app/pages/complete-migration/sources-tabs.js